import React from 'react';
import * as S from './RightBlockGcc.styles';

import ProfileInfo from './ProfileInfo/ProfileInfo';
import CompanyInfo from './CompanyInfo/CompanyInfo';
import SupportingInfo from './SupportingInfo/SupportingInfo';

const RightBlockGcc = ({onEditClick}) => {
  return (
    <S.RightBlockMainWrap>
      <S.RightInnerWrap>
        <ProfileInfo />
        <CompanyInfo onEditClick={onEditClick}/>
        <SupportingInfo />
      </S.RightInnerWrap>
    </S.RightBlockMainWrap>
  );
};

export default RightBlockGcc;
